@if (position === OperatorPosition.right) {
  <div>
    @if (showOperatorsPermanently == false) {
      <div class="operators-content">
        <opath-core-nav-header
          style="width: 100%"
          [title]="translation.operators.title"
          [buttons]="operatorButtons"
          [height]="100"
          [hideFilterPanel]="true"
          (onFilterOptionChanged)="filterOptionChanged($event)"
          (onSearchTermChanged)="searchTermChanged($event)"
          >
        </opath-core-nav-header>
        @if (position === OperatorPosition.right) {
          <div class="operators-wrapper">
            @for (operator of oPathOperators; track operator) {
              <abc-button
                [width]="'35px'"
                [text]="operator.identifier"
                (click)="onOperatorClick(operator)"
                class="operator-button"
                [toolTipContent]="operator.description"
                >
              </abc-button>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (position !== OperatorPosition.right) {
  <div
    [class]="position === OperatorPosition.left ? 'container-left-position' : 'container-bottom-position'"
    [style.height]="position === OperatorPosition.left ? height + 'px' : '100%'"
    [style.width]="position === OperatorPosition.left ? width + 'px' : '100%'"
    >
    <abc-button
      (click)="changePosition(OperatorPosition.right)"
      icon="close"
      [toolTipContent]="translation?.operators.unpin"
      [style.order]="position === OperatorPosition.left ? 1 : 3"
    [ngClass]="
      position === OperatorPosition.left ? 'left-position-close action-btn' : 'buttom-position-close action-btn'
    "
    ></abc-button>
    <div class="buttons-container" id="buttons-container" [style.order]="2">
      @for (operator of oPathOperators; track operator) {
        <abc-button
          (click)="onOperatorClick(operator)"
          [width]="'35px'"
          [text]="operator.identifier"
          class="operator-button"
          [toolTipContent]="operator.description"
          >
        </abc-button>
      }
    </div>
    <abc-button
    (click)="
      position === OperatorPosition.left
        ? changePosition(OperatorPosition.bottom)
        : changePosition(OperatorPosition.left)
    "
      [style.order]="position === OperatorPosition.left ? 3 : 1"
      [icon]="position === OperatorPosition.left ? 'chevrondown' : 'chevronleft'"
      [toolTipContent]="translation?.operators.changePosition"
    [ngClass]="
      position === OperatorPosition.left
        ? 'left-position-chevrondown action-btn'
        : 'buttom-position-chevronleft action-btn'
    "
    ></abc-button>
  </div>
}
